// menu.js
import { trapFocus } from '../helpers/index.js';

const hamburger = document.getElementById('hamburger');
const nav = document.getElementById('nav');

if (hamburger && nav) {
  function toggleMenu() {
    const isOpen = hamburger.getAttribute('aria-expanded') === 'true';

    if (!isOpen) {
      openMenu();
    } else {
      closeMenu();
    }
  }

  let releaseFocus = null;

  function openMenu() {
    hamburger.setAttribute('aria-expanded', 'true');
    nav.classList.add('is-open');
    document.documentElement.classList.add('no-scroll');
    releaseFocus = trapFocus(nav);
  }

  function closeMenu() {
    nav.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');
    hamburger.setAttribute('aria-expanded', 'false');
    if (releaseFocus) {
      releaseFocus();
      releaseFocus = null;
    }
  }

  hamburger.addEventListener('click', toggleMenu);

  nav.addEventListener('keyup', (e) => {
    if (e.code === 'Escape') {
      closeMenu();
    }
  });

  document.addEventListener('click', (e) => {
    const isHamburgerClick =
      e.target === hamburger || hamburger.contains(e.target);
    const isNavClick = e.target.closest('#nav') !== null;

    if (!isHamburgerClick && !isNavClick) {
      closeMenu();
    }
  });

  window.addEventListener('resize', () => {
    closeMenu();
  });

  // Dropdown toggle for mobile: click parent item to toggle submenu
  const parentItems = nav.querySelectorAll('.menu-item-has-children > a');
  parentItems.forEach((link) => {
    link.addEventListener('click', (e) => {
      // On mobile, toggle submenu instead of navigating
      if (window.innerWidth < 960) {
        e.preventDefault();
        const parentLi = link.parentElement;
        parentLi.classList.toggle('is-open');
      }
    });
  });
}
